import {BaseDocument} from '@/store/type';

export enum MemberServiceType {
  ServiceProvider = 'Service Provider',
  ServiceReceiver = 'Service Receiver'
}
export interface ServiceFormSearch {
  branchId?: string | null;
  communityId?: string | null;
  days?: string[]
  serviceId?: string | null;
  subServiceId?: string | null;
  serviceType: MemberServiceType;
  crossBranch: boolean;
}

export interface ServiceSearchResultInterface {
  firstName: string;
  lastName: string;
  select: boolean;
  address: string;
  profile: string;
  image: string;
  mobilePhone: string;
  branch: string;
  community: string;
  lineId: string;
  id: string;
}

export interface ServiceSearchResultComponentInterface {
  fetchResult: () => Promise<void>
}

export interface ServiceSearchComponentInterface {
  serviceFormSearch: ServiceFormSearch;

}

export interface Invite {
  memberId: string;
  inviteId: string;
  serviceDate: Date;
  serviceStartDate: Date;
  remark: string;
  phone: string;
  location: string;
  serviceTransactionStatus: BaseDocument | 'waiting'; // สถานะการตอบรับ
  serviceType: MemberServiceType
  subServiceId: string;
  refNo?: string; // ไม่ต้องส่งไป เดี๋ยวสร้างให้
  code?: string; //สร้างโคดเพื่อให้ลูกจ้างกรอกเริ่มงาน (สร้างตอนเริ่มงาน)
  finalCode?: string; //ใส่เพื่อหยุดการทำงาน (สร้างตอนส่งงาน)
}
